const StepInstructionScreenConfig = {
    FRAME_OUTER_RADIUS_MULTIPLIER: 1.1,
    FRAME_SEGMENTS: 4,
    FRAME_RINGS: 1,
    FRAME_START_ANGLE: Math.PI / 4,
    
    FRAME_OPACITY: 0.5,
    
    VR_POSITION_X: -1.527082,
    VR_POSITION_Y: 0.8302130,
    VR_POSITION_Z: -2.8028,
    
    MIN_SCALE_X: .3,
    SCALE_SENSITIVITY: 0.01,
    
    BUTTON_MARGIN: 0.005,
    BUTTON_BORDER_WIDTH: 0.002,
    BUTTON_OFFSET: 0.000001,
    BUTTON_TEXTURE_SCALE: 0.6,
    BUTTON_SIZE_MULTIPLIER: 0.62,
    
    PANEL_BUTTON_SIZE: 0.1,
    PANEL_BUTTON_SPACING: 0.12,
    PANEL_BUTTON_ALPHA_TEST: 0.1,
    PANEL_BUTTON_Z_OFFSET: 0.05,
    PANEL_BUTTON_Y_OFFSET: 0.2,
    
    TEXT_CONTAINER_HEIGHT_RATIO: 0.15,
    UNDERLINE_HEIGHT_RATIO: 0.015,
    ADDITIONAL_TEXT_HEIGHT_RATIO: 0.55,
    BUTTON_CONTAINER_HEIGHT_RATIO: 0.28,
    LEFT_BUTTON_CONTAINER_WIDTH_RATIO: 0.4,
    RIGHT_BUTTON_CONTAINER_WIDTH_RATIO: 0.6,
    CONTENT_CONTAINER_WIDTH_RATIO: 0.9,
    
    FONT_SIZE_HEADING: 0.063,
    FONT_SIZE_ADDITIONAL: 0.0494,
    
    UI_SPACING: 0.075,
    UI_MARGIN: 0.02
};

export default StepInstructionScreenConfig;
